import { useState, useContext, useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  SentimentSatisfiedAlt as SentimentSatisfiedAltIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { FaPaperclip, FaStethoscope } from "react-icons/fa";
import { GoPaperAirplane } from "react-icons/go";
//import InfiniteScroll from "react-infinite-scroll-component";
import Cookies from "js-cookie";
import moment from "moment";

import { searchProduct } from "../../../services/searchApi";
import { GlobalStateContext } from "../../../components/context/GlobalStateContext";
import RecipeConsultation from "../../../components/common/RecipeConsultation";
import RecipeDigital from "../../../assets/Resep-Digital.png";

import {
  addToCart,
  getListCartInfo,
  addDoctorRecipe,
  uploadImage,
  getListCartInfoJwt,
} from "../../../services/purchaseApi";
import Recipe from "../../../assets/resep.png";
import CountCartInfo from "../cart/CountCartInfo";
import ProductCard from "./ProductCard";
import ModalChatCustomer from "../../chat/ModalChatCustomer";
import ErrorPopup from "../../../components/common/ErrorPopup";
import { listProduct } from "../../../services/productApi";
import ProductCardNew from "./ProductCardNew";
import NotFound from "../../../assets/notFound.png";

const FETCH_LIMIT = 12;

const ProductListCategory = () => {
  const { recipeId, setRecipeId, isLogin } = useContext(GlobalStateContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const machineId = localStorage.getItem("MachineId");

  const [data, setData] = useState(null);
  const [offset, setOffset] = useState(1);
  const [fetchLimit, setFetchLimit] = useState(FETCH_LIMIT);
  const [hasMore, setHasMore] = useState(true);
  const [items, setItems] = useState([]);
  const [openModalChatRecipe, setOpenModalChatRecipe] = useState(false);
  const [imgBuffer, setImgBuffer] = useState([]);
  const [recipeImgUrl, setRecipeImgUrl] = useState([]);
  const [openModalRecipe, setOpenModalRecipe] = useState(false);
  const [open, setOpen] = useState(false);
  const [chatRecipeResponse, setChatRecipeResponse] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [companyId, setCompanyId] = useState(
    localStorage.getItem("companyId") || "",
  );
  const [doctorRecipe, setDoctorRecipe] = useState({
    product_id: 0,
    company_id: 0,
    quantity: 0,
    product_name: "",
    freq_type: "per jam",
    consumed: "6 setiap jam",
    consumption_interval: "jumlah yang harus di minum 1",
    price: 0,
    expired_at: "",
    notes:
      "Pemakaian obat umumnya memiliki efek samping tertentu dan sesuai dengan masing-masing individu. Jika terjad efek samping yang berlebih dan berbahaya, harap konsultasikan kepada tenaga medis. Efek samping yang mungkin terjadi dalam penggunaan obat adalah: Anoreksia, mual dan gangguan GI.",
  });
  const [addToCartProduct, setAddToCartProduct] = useState({
    company_id: 0,
    price: 0,
    product_id: 0,
    recipe_id: recipeId,
    product_name: "",
    image: [],
    product_type: "",
    stock: 0,
    quantity: 0,
    prescription_image: [],
    check_state: true,
    uuid: machineId,
  });

  const [reqBody, setReqBody] = useState({
    company_id: companyId ? Number(companyId) : 0,
    limit: fetchLimit,
    offset: offset,
    keyword: "",
    category_id: id ? Number(id) : 0,
    higher_price: 0,
    lower_price: 0,
    sort_by: 0,
  });

  const { mutate: mutateUploadImage, isPending } = useMutation({
    mutationFn: uploadImage,
    onSuccess: (data) => {
      setData(data);
      queryClient.invalidateQueries({
        queryKey: ["prescription-preview"],
      });
    },
  });

  useEffect(() => {
    if (data && data.url) {
      setRecipeImgUrl((prevUrls) => [...prevUrls, data.url]);
    }
  }, [data]);

  useEffect(() => {
    setAddToCartProduct((prevProduct) => ({
      ...prevProduct,
      prescription_image: recipeImgUrl,
    }));
  }, [recipeImgUrl]);

  useEffect(() => {
    setAddToCartProduct((prevProduct) => ({
      ...prevProduct,
      recipe_id: recipeId,
    }));
  }, [recipeId]);

  const handleAddToCart = (body) => {
    mutateAddToCart(body);
  };

  const { data: countCartData, isLoading: isCountCartLoading } = useQuery({
    queryKey: ["count-cart"],
    queryFn: () => getListCartInfo(),
    enabled: !isLogin,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  const { mutate: mutateList, isPending: isListLoading } = useMutation({
    mutationFn: listProduct,
    onSuccess: (data) => {
      if (!data) setHasMore(false);
      if (data && data !== undefined) {
        setItems(
          data.map((data) => ({
            ...data,
            isLoading: false,
          })),
        );
      }
    },
  });

  useEffect(() => {
    setItems([]);
    mutateList(reqBody);
  }, [reqBody]);

  const { mutate: mutateAddDoctorRecipe } = useMutation({
    mutationFn: addDoctorRecipe,
    onSuccess() {
      setOpenModalRecipe(false);
      setOpenModalChatRecipe(false);
      setOpen(false);
      setImgBuffer([]);
      handleAddToCart(addToCartProduct);
    },
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  const handleSuccessAddToCart = () => {
    setImgBuffer([]);
    setRecipeId(null);
    queryClient.invalidateQueries({
      queryKey: ["count-cart"],
    });
    queryClient.invalidateQueries({
      queryKey: ["count-cart-jwt"],
    });
    setItems((prevValue) =>
      prevValue.map((data) => ({ ...data, isLoading: false })),
    );
  };

  const { mutate: mutateAddToCart, isLoading: isAddToCartLoading } =
    useMutation({
      mutationFn: addToCart,
      onSuccess: () => handleSuccessAddToCart(),
      onError: (error) => {
        setErrorMessage(
          error.message || "Terjadi kesalahan saat menambahkan ke keranjang.",
        );
      },
    });

  // useEffect(() => {
  //   const body = {
  //     limit: fetchLimit,
  //     offset: offset,
  //     keyword: search,
  //     company_id: Number(companyId),
  //   };
  //   setItems([]);
  //   mutateList(body);
  // }, [offset, search, Cookies, fetchLimit, companyId]);

  useEffect(() => {
    // listen for changes to companyId in localStorage
    const handleStorage = (e) => {
      if (e.key === "companyId") {
        setCompanyId(e.newValue || "");
      }
    };

    window.addEventListener("storage", handleStorage);

    // observe company id
    const observer = new MutationObserver(() => {
      setCompanyId(localStorage.getItem("companyId") || "");
    });
    observer.observe(document, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => {
      window.removeEventListener("storage", handleStorage);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (recipeId !== null) {
      setImgBuffer([RecipeDigital]);
    } else {
      setImgBuffer([]);
    }
  }, [recipeId]);

  return (
    <>
      {
        <div className="mb-4">
          <div
            className={`w-full grid ${items.length === 0 ? "grid-cols-1" : "grid-cols-2"} sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2`}
          >
            {isListLoading && items.length === 0 ? (
              <CircularProgress size={20} />
            ) : items && items.length > 0 ? (
              items.map((item, i) => (
                <ProductCardNew item={item} isLoading={false} />
              ))
            ) : (
              <div className="min-h-[calc(100vh-150px)] w-full flex items-center justify-center">
                <div className="flex flex-col items-center justify-center text-slate-700 px-4">
                  <img src={NotFound} alt="Not Found" className="w-1/2 mb-3" />
                  <h1 className="font-semibold text-lg">
                    Tidak Ada Hasil Yang Sesuai
                  </h1>
                  <p className="text-center text-md mt-2">
                    Tidak ada produk yang sesuai dengan kategori ini
                  </p>
                  <button
                    onClick={() => navigate(-1)}
                    className="h-[40px] text-base mt-3 border border-secondary flex items-center justify-center bg-secondary text-white w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryActive transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-disabled"
                  >
                    Kembali
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      }

      <div className="mb-4">
        {data?.count >= fetchLimit ? (
          <div>
            {isListLoading ? (
              <button className="text-blue-500 p-3.5 border-2 border-blue-500 rounded-md text-center mt-4 hover:bg-slate-100 w-full">
                <CircularProgress size={20} />
              </button>
            ) : (
              <button
                className="border-2 rounded-md p-2 bg-[#F1FAF0] border-[#6F955B] text-[#6F955B] w-full hover:bg-gray-200"
                onClick={() => {
                  setFetchLimit((prevValue) => prevValue + 12);
                }}
              >
                Muat Lebih Banyak
              </button>
            )}
          </div>
        ) : null}
      </div>

      <Dialog
        open={openModalRecipe}
        onClose={() => {
          setOpenModalRecipe(false);
          setImgBuffer([]);
          setRecipeImgUrl([]);
          setAddToCartProduct({
            company_id: 0,
            price: 0,
            product_id: 0,
            recipe_id: recipeId,
            product_name: "",
            image: [],
            product_type: "",
            stock: 0,
            quantity: 0,
            prescription_image: [],
            check_state: true,
            uuid: machineId,
          });
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Resep dokter yang diperlukan</DialogTitle>
        <DialogContent>
          <div>
            <p>Syarat foto resep dokter</p>
            <div className="flex">
              <img src={Recipe} alt={Recipe} />
              <div className="ml-3 ">
                <p>
                  <span className="mr-2 rounded-full bg-blue-500 px-2 py-1 text-white font-bold">
                    1
                  </span>
                  Pastikan seluruh bagian kertas terlihat dan dapat terbaca
                </p>
                <p className="my-3">
                  <span className="mr-2 rounded-full bg-blue-500 px-2 py-1 text-white font-bold">
                    2
                  </span>
                  Upload foto resep sesuai dengan obat yang dibeli
                </p>
                <p>
                  <span className="mr-2 rounded-full bg-blue-500 px-2 py-1 text-white font-bold">
                    3
                  </span>
                  Boleh upload lebih dari 1 resep dari dokter/klinik/kunjugan
                  berbeda
                </p>
              </div>
            </div>
          </div>
          <div className="border my-3"></div>
          <p>upload foto resep</p>
          {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
          <div className="mt-3 flex">
            {imgBuffer.map((data) => (
              <img
                className="w-[100px] border rounded-md ml-3"
                src={data}
                alt={Recipe}
              />
            ))}
            {imgBuffer === 3 ? null : (
              <label
                htmlFor="dropzone-file1"
                //className="cursor-pointer flex flex-col items-center justify-center w-[15%] p-6 border-2 rounded-md"
              >
                <input
                  id="dropzone-file1"
                  hidden
                  type="file"
                  accept="image/jpeg, image/png, image/jpg"
                  multiple
                  onChange={(e) => {
                    const newImg = Array.from(e.target.files);
                    newImg.forEach((file) => {
                      if (file) {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          setImgBuffer((prevImages) => [
                            ...prevImages,
                            reader.result,
                          ]);
                        };
                        reader.readAsDataURL(file);
                      }
                    });
                    mutateUploadImage(e.target.files[0]);
                  }}
                />

                <div className="text-[100px] border p-9 rounded-md ml-3 cursor-pointer">
                  <FaPaperclip fontSize="large" sx={{ color: "black" }} />
                </div>
              </label>
            )}
          </div>
        </DialogContent>
        <DialogActions className="mx-4 mb-3">
          {recipeId !== null ? null : (
            <button
              className="rounded-lg border border-gray-300 w-full py-2 flex items-center justify-center font-semibold hover:bg-gray-100 disabled:bg-gray-100 disabled:border-gray-100"
              onClick={() => setOpenModalChatRecipe(true)}
              disabled={imgBuffer.length >= 1}
            >
              <FaStethoscope className="h-[18px] w-[18px] text-gray-500" />
              <p className="ml-2 text-gray-500">Konsultasi Dokter</p>
            </button>
          )}
          <button
            className={`rounded-lg border border-blue-500 py-2 text-white font-semibold bg-blue-500 ml-3 disabled:bg-gray-300 disabled:border-gray-300 flex items-center justify-center hover:bg-blue-700 ${
              recipeId !== null ? "w-full" : "w-[30%]"
            }`}
            disabled={isPending || imgBuffer.length < 1}
            onClick={() => {
              mutateAddDoctorRecipe(doctorRecipe);
            }}
          >
            {!data && isPending ? (
              <CircularProgress size={24} />
            ) : (
              <>
                <p className="">Selesai</p>{" "}
                <GoPaperAirplane className="h-[20px] w-[20px] ml-2" />
              </>
            )}
          </button>
        </DialogActions>
      </Dialog>

      <ModalChatCustomer
        openChat={openModalChatRecipe}
        setOpenChat={setOpenModalChatRecipe}
        drugData={addToCartProduct}
      />

      {/* <CountCartInfo
        countCart={countCartData}
        isCountCartLoading={isCountCartLoading}
        isAddToCartLoading={isAddToCartLoading}
      /> */}

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </>
  );
};

export default ProductListCategory;
